import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NoosFormTypeService} from '../../../../../class/NoosFormTypeService';
import {IFormItems} from '../../../../../interface/form-structure';
import {StepperSelectionEvent} from '@angular/cdk/stepper';
import {IWizardViewOutput} from '../../../../../interface/component';
import {IViewComponent, IViewStepperComponent} from '../../../../../interface/panels';
import {MatHorizontalStepper} from '@angular/material/stepper';

@Component({
    selector: 'noos-form-container-stepper',
    templateUrl: './form-container-stepper.component.html',
    styleUrls: ['./form-container-stepper.component.scss']
})
@NoosFormTypeService.register('ViewFORMwizard')
export class FormContainerStepperComponent implements OnInit, IViewComponent, IViewStepperComponent {

    @ViewChild('stepper', {static: true}) stepperComponent: MatHorizontalStepper;

    formJson: IFormItems[];
    isFilter: boolean;
    totalStep = 1;

    @Output()
    changeStep = new EventEmitter<IWizardViewOutput>();

    @Output()
    keyOnEnter = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }

    ngOnInit() {
        this.totalStep = this.formJson.length;
        this.changeStep.emit({currentStep: 1, totalStep: this.totalStep});
    }

    onSelectChange($event: StepperSelectionEvent) {
        this.changeStep.emit({currentStep: $event.selectedIndex + 1, totalStep: this.totalStep});
    }

    public onNext() {
        this.stepperComponent.next();
    }

    public onPrev() {
        this.stepperComponent.previous();
    }

    onEnterEvent($event: any) {
        this.keyOnEnter.emit();
    }

}
